/* eslint-disable sonarjs/cognitive-complexity */

'use strict';

var afterpayWidget = require('../product/afterpayWidget');
var klarnaOsm = require('../common/klarnaOsm');

var utils = require('../utils');
var getAmountToDisplay = utils.getAmountToDisplay;

/**
 * updates the totals summary
 * @param {Array} totals - the totals data
 * @param {Array} shipping - the shipping data
 * @param {Array} resources - the resources data
 */
function updateTotals(totals, shipping, resources) {// eslint-disable-line

    // Make sure the method is a valid shipping method
    var shippingMethod = shipping.length > 0 ? shipping.filter(function (item) {
        return item.selectedShippingMethod && !item.selectedShippingMethod.storePickupEnabled;
    })[0] : null;

    // Update shipping method cards for non BOPIS & non E-gift line items
    if (shippingMethod) {
        $('.shipping-method-name:not(.bopis-method):not(.egift-method):not(.pre-order):not(.back-order)').text(shippingMethod.selectedShippingMethod.displayName);
    }

    $('.shipping-total-cost').text(getAmountToDisplay(totals.totalShippingCost));
    $('.tax-total').text(totals.totalTax);
    $('.sub-total').text(getAmountToDisplay(totals.subTotal));
    $('.grand-total-sum').text(getAmountToDisplay(totals.grandTotal));
    if ($('.order-total-summary').find('.manual-afterpay-widget').length > 0) {
        $('.manual-afterpay-widget').empty();
    }
    klarnaOsm.updateTotal(totals.grandTotal.replace(/[NZA$]/g, ''));
    afterpayWidget.getWidget(null, totals.grandTotal.replace(/[NZA$]/g, ''), 'checkout-afterpay-message');

    if (totals.crdf && totals.crdf !== '' && totals.crdf !== 'undefined') {
        $('.crdf-tax-item').removeClass('d-none');
        $('.crdf-tax-total').text(totals.crdf);
    } else {
        $('.crdf-tax-item').addClass('d-none');
    }

    var orderLevelDiscounts = totals && totals.orderDiscountsTemplate ? totals.orderDiscountsTemplate : '';
    $('#js-order-level-dicounts').empty().html(orderLevelDiscounts);

    if (totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').text('- ' + getAmountToDisplay(totals.orderLevelDiscountTotal.formatted));
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').text('- '
           + getAmountToDisplay(totals.shippingLevelDiscountTotal.formatted));
        // if (totals.shippingLevelDiscountTotal.value === totals.totalShippingCostValue) { // commented for SFRA-6148
        // $('.shipping-total-cost').empty().append(resources.freeLabel);
        // }
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    if (totals.gcTotal && totals.gcTotal.value > 0) {
        $('.giftcertificate-item').removeClass('d-none');
        $('.gift-card-total').text('- ' + totals.gcTotal.formatted);
    } else {
        $('.giftcertificate-item').addClass('d-none');
    }
}

/**
 * updates the order product shipping summary for an order model
 * @param {Object} order - the order model
 */
function updateOrderProductSummaryInformation(order) {
    // Update shipping methods in summary area
    if (order.renderedShippingMethods) {
        $('.shipping-methods-summary').html(order.renderedShippingMethods);
    }

    // Also update the line item prices, as they might have been altered
    $('.grand-total-price').text(getAmountToDisplay(order.totals.grandTotal));
    order.items.items.forEach(function (item) {
        if (item.priceTotal && item.priceTotal.renderedPrice) {
            $('.checkout-item-price-summary-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
        }
    });
}
module.exports = {
    updateTotals: updateTotals,
    updateOrderProductSummaryInformation: updateOrderProductSummaryInformation
};
